import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/apiClient";
import { STATUS_STYLES } from "../lib/statusConfig";
import { styleFromBase } from "../lib/colorUtils";
import { useAuth } from "./AuthContext";

const ColorContext = createContext(null);

const DEFAULT_STATUS = { bg: "#F4F4F5", text: "#52525B", border: "#E4E4E7", dot: "#A1A1AA" };
const DISCIPLINE_NA = { bg: "#F4F4F5", text: "#71717A", border: "#E4E4E7", dot: "#A1A1AA" };
const DISCIPLINE_DEFAULT = { bg: "#EEF2FF", text: "#4338CA", border: "#E0E7FF", dot: "#6366F1" };

export function ColorProvider({ children }) {
  const { user } = useAuth();
  const [overrides, setOverrides] = useState({ statuses: {}, disciplines: {} });

  const refresh = useCallback(() => {
    api.get("/colors").then((r) => setOverrides({ statuses: r.data.statuses || {}, disciplines: r.data.disciplines || {} })).catch(() => {});
  }, []);

  useEffect(() => { if (user) refresh(); }, [user, refresh]);

  const statusStyle = useCallback((name) => {
    const c = overrides.statuses?.[name];
    if (c) return styleFromBase(c);
    return STATUS_STYLES[name] || DEFAULT_STATUS;
  }, [overrides]);

  const disciplineStyle = useCallback((name) => {
    const c = overrides.disciplines?.[name];
    if (c) return styleFromBase(c);
    return (!name || name === "N/A") ? DISCIPLINE_NA : DISCIPLINE_DEFAULT;
  }, [overrides]);

  const defaultStatusColor = (name) => (STATUS_STYLES[name]?.dot || DEFAULT_STATUS.dot);
  const defaultDisciplineColor = (name) => ((!name || name === "N/A") ? DISCIPLINE_NA.dot : DISCIPLINE_DEFAULT.dot);

  return (
    <ColorContext.Provider value={{ overrides, refresh, statusStyle, disciplineStyle, defaultStatusColor, defaultDisciplineColor }}>
      {children}
    </ColorContext.Provider>
  );
}

export const useColors = () => useContext(ColorContext);
